import { render, staticRenderFns } from "./managerChooseProductType.vue?vue&type=template&id=8be1edb8&scoped=true&"
import script from "./managerChooseProductType.vue?vue&type=script&lang=js&"
export * from "./managerChooseProductType.vue?vue&type=script&lang=js&"
import style0 from "./managerChooseProductType.vue?vue&type=style&index=0&id=8be1edb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1edb8",
  null
  
)

export default component.exports